import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
declare let window: any;

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private appConfig;
  urlStr:string;
  isProduction: boolean;
  environment: string;
   


  constructor(private http: HttpClient) {
    
   }

  loadAppConfig() {
   // console.log("inside load app " );
   // var url = new URL(window.location.href);
  //  console.log("Loading app configurations from " + url);
    this.urlStr=window.location.hostname;
  
    let configurl;
   // console.log("host " +  this.urlStr);
    if (this.urlStr=== 'localhost') {
      configurl = '/app-local.config.json';
    } else
      
        {
            if(this.urlStr==='qadeveloperportal.aetna.com') {
          
          //  configurl = 'https://qadeveloperportal.aetna.com/app-qa.config.json';

            configurl = '/app-qa.config.json';
        }
            else{
              if(this.urlStr==='devdeveloperportal.aetna.com') {
               // configurl = 'https://devdeveloperportal.aetna.com/app-dev.config.json';   
               configurl = '/app-dev.config.json';   
                
              }else{
              //  configurl='https://'+this.urlStr+'/app-prod.config.json';
              if(this.urlStr==='iopapicdeveloperportal-oci-stress.aetapps-qa.aetna.com') {
                configurl = '/app-stress.config.json';
                  }else{
                      configurl='/app-prod.config.json';
                  }
              }
  }        }
  
    console.log("final url " + configurl);
    return this.http.get(configurl)
      .toPromise()
      .then(data => {
        window.config = data;
        this.appConfig = data;
        return;
      });
  }

  getConfig() {
    return this.appConfig;
  }
}
